<template>
  <v-main class="pa-4" fluid>
    <v-row>
      <v-col cols="12" >
        <v-card  class="shadowCard" >
          <v-card-title primary-title>
	  		    <span class="text-h6 textgrey--text"><b>Catálogo de Artículos</b></span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn tile color="primary" dark small class="mr-2" @click="dialogNewProducto.estatus = true">
              <v-icon small left> mdi-plus </v-icon>
              Agregar
            </v-btn>

            <v-btn tile color="secondary" dark small class="mr-2" @click="initialize">
              <v-icon small left> mdi-refresh </v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
          
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  dense
                  hide-details
                  append-icon="mdi-magnify" 
                  v-model="search"
                  clearable
                  filled
                  single-line
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="productos"
                  class="elevation-0"
                  :search="search"
                  fixed-header
                  dense
                  :loading ="Loading"
                  :height="tamanioPantalla"
                >
                  <template v-slot:item.editar="{ item }">
                    <v-btn icon x-small color="success" class="my-1" @click="edit(item)">
                      <v-icon>mdi-pencil </v-icon>
                    </v-btn>

                  </template>
                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                    >
                      Actualizar
                    </v-btn>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-chip v-if="item.estatus == 1" color="green" dark small>Activo</v-chip>
                    <v-chip v-else color="red" dark small>Inactivo</v-chip>
                  </template>

                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                    >
                      Actualizar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            
          </v-card-text>
        </v-card>
      
      </v-col>
    </v-row>

    <NewProducto
      :dialogNewProducto="dialogNewProducto"
      v-if="dialogNewProducto.estatus"
      @initialize="initialize"
    />

  </v-main>
</template>


<script>
  import  metodos from '@/mixins/metodos.js';
  import {mapActions, mapGetters} from 'vuex'

  import NewProducto from '@/views/clasificacion/arts/NewProducto.vue'

  import XLSX from 'xlsx'

  export default {

    components:{
      NewProducto
    },


    mixins:[metodos],

    data: () => ({
      downloadLoading:false,

      Loading: true,
      longitud:5,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      search:'',
      productos:[],
      headers: [
        { text: 'Codigo', align: 'left', value: 'codigo'},
        { text: 'Nombre', align: 'left', value: 'nomart'},
        { text: 'Precio', align: 'left', value: 'precio1'},
        // { text: 'Familia',               value: 'familia' },
        // { text: 'Categoria',             value: 'categoria' },
        // { text: 'Subcategoria',          value: 'subcategoria' },
        { text: 'Editar',                value: 'editar' },
      ],

      url: '',

      dialogNewProducto:{
        estatus: false
      }

      
    }),

    created(){
      this.url = this.$http.options.root + 'fotos-epic-grass//'
      this.initialize()
    },

    methods:{
      ...mapActions('productos',['traerProductos','addImg', 'verProducto']),
      initialize(){
        this.productos = []
        this.Loading = true
        this.$http.get('articulos.list').then(response =>{
          this.loading = false
          this.productos = response.body
        }).catch(error=>{
          this.Loading = false
        }).finally(()=>{
          this.Loading = false

        })
      },
      
      // EXCEL
      exportar(){
        let xls = {
          data:      this.productos,
          tHeaders : ['Codigo','Nombre', 'Sal', 'Labortorio'],
          filterVal: ['codigo','nomart', 'sal', 'lab'],
          nomfile :  "Productos"
        }
        this.exportExcel()
      },

      s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

      exportExcel(){
        this.productos.sort((a , b)=>{
          if (a.nomart > b.nomart) {
            return 1;
          }
          if (a.nomart < b.nomart) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });

        let data = XLSX.utils.json_to_sheet(this.productos)
        const workbook = XLSX.utils.book_new()
        const filename = 'Productos'
        XLSX.utils.book_append_sheet(workbook, data, filename)

        var wbout = XLSX.write(workbook, {
          bookType: 'xls',
          bookSST: false,
          type: 'binary'
        });

        const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
        console.log(file)
        
        let formData = new FormData();
        // //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file',file);
        // /*Initialize the form data*/
        console.log('formData', formData)

        this.$http.post('pdfs',formData).then(response=> {
          // alert(response.body)
          window.location = this.$http.options.root + 'pdfs/' + filename + '.xls'
        }).catch(error=> {
          alert(error.body)
          console.log(error);
        });

      },

      edit(item){
        this.verProducto(item)
        this.$router.push({name:'tabproducto', params: {id: item.codigo}})
      }
    },

    computed:{
      ...mapGetters('productos',['getProductos'])
    }

  }
</script>





